import { render, staticRenderFns } from "./Clip.vue?vue&type=template&id=22472b63&scoped=true"
import script from "./Clip.vue?vue&type=script&lang=js"
export * from "./Clip.vue?vue&type=script&lang=js"
import style0 from "./Clip.vue?vue&type=style&index=0&id=22472b63&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22472b63",
  null
  
)

export default component.exports